import moment from "moment";
export const getLeads = (state) => {
  let dataMap = state.leads.map((element) => {
    element.full_name = `${element.first_name} ${element.last_name}`;
    element.owner_name = element.user_info
    return element;
  });
  console.log("la data mapeada: ", dataMap);
  return dataMap;
};
export const getPersons = (state) => {
  let dataMap = state.persons.map((element) => {
    element.full_name = `${element.first_name} ${element.last_name}`;
    element.owner_name = element.user_info
    return element;
  });
  console.log("la data mapeada: ", dataMap);
  return dataMap;
};
export const getterFacebook = (state) => {
  let dataMap = state.facebook.map((element) => {
    element.full_name = `${element.first_name} ${element.last_name}`;
    return element;
  });
  console.log("la data mapeada: ", dataMap);
  return dataMap;
};
export const getterCrm= (state) => {
  let dataMap = state.crm.map((element) => {
    element.full_name = `${element.first_name} ${element.last_name}`;
    return element;
  });
  console.log("la data mapeada: ", dataMap);
  return dataMap;
};
export const getterRecompra= (state) => {
  let dataMap = state.recompra.map((element) => {
    element.full_name = `${element.first_name} ${element.last_name}`;
    return element;
  });
  console.log("la data mapeada: ", dataMap);
  return dataMap;
};
export const getterJoin = (state) => {
  let dataMap = state.join.map((element) => {
    element.full_name = `${element.first_name} ${element.last_name !== null ? element.last_name : '' }`;
    return element;
  });
  console.log("la data mapeada: ", dataMap);
  return dataMap;
};
export const getterFormulario = (state) => {
  let dataMap = state.formulario.map((element) => {
    element.full_name = `${element.first_name} ${element.last_name}`;
    return element;
  });
  console.log("la data mapeada: ", dataMap);
  return dataMap;
};
export const getBusiness = (state) => {
  let mapBusiness = state.business.map((business) => {
    let mapBusinessArr = business.business.map((businessObj) => {
      businessObj.full_name = `${business.first_name} ${business.last_name}`;
      businessObj.position = `${business.position}`;
      businessObj.mobile = `${business.mobile}`;
      businessObj.email = `${business.email}`;
      businessObj.id = `${business.id}`;
      return businessObj;
    });
    return mapBusinessArr;
  });
  console.log("lista de listas negocios: ", mapBusiness);
  const listaUnida = mapBusiness.reduce((acumulador, listaInterna) => {
    // Concatenar la lista interna al acumulador
    return acumulador.concat(listaInterna);
  }, []);
  console.log("lista de negocios unida: ", listaUnida);
  return listaUnida;
};
export const getBusiness2 = (state) => {
  let mapBusiness = state.business.map((element) => {
    element.personFull_name = `${element.first_name} ${element.last_name}`;
    element.totalCurrency = toCurrency(element.total_amount);
    element.owner_name = element.full_name

    return element;
  });
  return mapBusiness;
};
export const getSales = (state) => {
  let mapSales = state.sales.map((element) => {
    element.personFull_name = `${element.first_name} ${element.last_name}`;
    element.totalCurrency = toCurrency(element.total_amount);
    element.owner_name = element.full_name

    return element;
  });
  return mapSales;
};
export const getNeeds = (state) => {
  let mapSales = state.needs.map((element) => {
    element.test = toCurrency(element.amount);

    return element;
  });
  return mapSales;
};
const toCurrency = (value) => {
  if (typeof value !== "number") {
    value = parseInt(value);
  }
  var formatter = new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
  });
  return formatter.format(value);
};

export const getterUsers = (state) => {
  let mapUsers = state.users.map((element) => {
    element.full_name = `${element.first_name} ${element.last_name}`;
    return element;
  });
  return mapUsers;
};
export const senders = (state) => {
  let mapSenders = state.senders.map((element) => {
    element.number = element.sender;
    element.date_message = formatDateMinutes(element.date_last_message);
    element.created_at = formatDateMinutes(element.date);
    return element;
  });
  return mapSenders;
};
export const getTypes = (state) => {
  return (state.eventTypes ?? []).map(item => ({
    title: item.name,
    value: item.name,
    has_link: item.has_link,
    id: item.id,
    is_active: item.is_active
  }));
};

const formatDateMinutes = (fecha) => {
  return moment(fecha).format("DD/MM/YYYY HH:mm");
};

export const getInteractions =
  (state) =>
  (busqueda = "") => {
    const interacciones = state.interactions.filter((usuario) =>
      Object.values(usuario).some((valor) =>
        valor.toString().toLowerCase().includes(busqueda.toLowerCase())
      )
    );
    console.log("las interacciones: ", interacciones);
    if (!interacciones) return;
    return { ...interacciones };
  };
export const getJoinSenders =
  (state) =>
  (busqueda = "") => {
    const senders = state.senders.filter((usuario) =>
      Object.values(usuario).some((valor) =>
        valor.toString().toLowerCase().includes(busqueda.toLowerCase())
      )
    );

    let mapSenders = senders.map((element) => {
      element.number = element.sender;
      element.date_message = formatDateMinutes(element.date_last_message);
      element.created_at = formatDateMinutes(element.date);
      return element;
    });
    if (!senders) return [];
    return { ...mapSenders };
  };
